// =============================================
// /src/pages/AvatarFrameGroupNew.tsx
// 新規作成ページ（v5 + v8 API 対応版）
// =============================================
import React from 'react';
import { useHistory } from 'react-router-dom'; // ← v5
import GenericTemplate from '../components/templates/GenericTemplate';
import { AvatarFrameGroupForm, emptyGroup } from './AvatarFrameGroupForm';
import {
  createAvatarFrameGroup,
  uploadFrameImage, // ← シグネチャ: (groupId, file, fileName?)
  isFrameIdUnique,
} from '../common/firebase/avatarFrames';

// import type { AvatarFrameGroup } from '@/types/avatarFrame'; // ← 未使用なら削除OK
import { Box, Paper, Stack, Typography } from '@mui/material';
import { BackToAvatarFrameList } from '../components/BackToAvatarFrameList';

const AvatarFrameGroupNew: React.FC = () => {
  const history = useHistory(); // ← v5
  const [value, setValue] = React.useState(emptyGroup());
  const [submitting, setSubmitting] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleUpload = async (idx: number, file: File) => {
    if (!value.id) return alert('先にグループIDを入力してください');
    const f = value.frames[idx];
    if (!f.id) return alert('先にフレームIDを入力してください');
    // v8 版: groupId のみ渡す
    const { uri, v } = await uploadFrameImage(value.id, file);
    const frames = value.frames.slice();
    frames[idx] = { ...f, uri, v };
    setValue({ ...value, frames });
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    setError(null);
    try {
      // 簡易ユニークチェック
      for (const f of value.frames) {
        if (f.id && !(await isFrameIdUnique(f.id))) {
          throw new Error(`Frame ID 重複: ${f.id}`);
        }
      }
      const ok = await createAvatarFrameGroup({
        ...value,
        lastRefreshAt: Date.now(), // ← これを付ける
      });
      if (ok) history.push('/AvatarFrameGroupList'); // ← v5
    } catch (e: any) {
      setError(e?.message ?? '作成に失敗しました');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <GenericTemplate title="アバターフレームグループ新規作成">
      <BackToAvatarFrameList mb={2} />
      <Box component={Paper} sx={{ p: 3 }}>
        <Stack spacing={2}>
          {/* <Typography variant="h5">アバターフレームグループ新規作成</Typography> */}
          {error ? <Typography color="error">{error}</Typography> : null}
          <AvatarFrameGroupForm
            mode="new"
            value={value}
            onChange={setValue}
            onUpload={handleUpload}
            onSubmit={handleSubmit}
            submitting={submitting}
          />
        </Stack>
      </Box>
    </GenericTemplate>
  );
};

export default AvatarFrameGroupNew;
